var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6147 7.77611L17.454 1.25776C16.9947 1.0462 16.5054 0.939453 15.9999 0.939453C15.4944 0.939453 15.0053 1.0462 14.5459 1.25776L0.385186 7.77611C0.151124 7.8843 0 8.12011 0 8.3778C0 8.63548 0.151124 8.8713 0.385186 8.97948L14.5459 15.4978C15.0052 15.7094 15.4944 15.8166 15.9999 15.8166C16.5054 15.8166 16.9947 15.7094 17.4541 15.4978L28.6298 10.3537V15.5338C28.1863 15.5838 27.8405 15.9613 27.8405 16.4174C27.8405 16.8148 28.1035 17.1589 28.4783 17.2685L27.7226 22.2554H31.2023L30.4467 17.2685C30.8214 17.1589 31.0844 16.8148 31.0844 16.4174C31.0844 15.9613 30.7386 15.5838 30.2951 15.5338V9.58704L31.6148 8.97948C31.8488 8.8713 32 8.63548 32 8.3778C32 8.12011 31.8487 7.8843 31.6147 7.77611Z",
    fill: "url(#paint0_linear_149_3306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.177C15.2971 18.177 14.616 18.0275 13.9758 17.733L7.04956 14.5444V20.8968C7.04956 22.2914 11.2637 24.0606 16 24.0606C20.7363 24.0606 24.9505 22.2913 24.9505 20.8968V14.5444L18.0238 17.733C17.384 18.0275 16.7031 18.177 16 18.177Z",
    fill: "url(#paint1_linear_149_3306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_3306",
    x1: 3.48125e-7,
    y1: 2.46201,
    x2: 32.6201,
    y2: 3.73789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_3306",
    x1: 7.04956,
    y1: 15.2242,
    x2: 25.2815,
    y2: 16.1177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsCount);
export default __webpack_public_path__ + "static/media/students_count.74a2dbd209ee888bfb1a1ceb218c68ff.svg";
export { ForwardRef as ReactComponent };